import { Injectable } from '@angular/core';
import { Logger } from "src/logger";

interface Entry {
    id: number;
    callback: (id: number) => void;
}

type ReservationState = "RESERVED" | "VACANT";

const LOG_TAG = 'tizenVideoReservationManager';

@Injectable({
    providedIn: "root"
})
export class TizenVideoReservationManager {

    public constructor(
        private readonly logger : Logger,
    ) {
    }

    private static generateId = (function() {
        let seed:number = 1;
        return () => {
            seed += 1;
            return seed;
        }
    })();

    private readonly entries: Array<Entry> = [];

    private reservationState: ReservationState = "VACANT"
    
    private reservedId: number = -1;

    private onChange() {
        if (this.reservationState === "VACANT" && this.entries.length > 0) {
            const nextLuckyEntry = this.entries[0];
            this.entries.splice(0, 1);
            this.reservationState = "RESERVED";
            this.logger.debug(LOG_TAG,  `TizenVideoReservationManager.onChange invoked. invoking callback ${nextLuckyEntry.id}`);
            nextLuckyEntry.callback(nextLuckyEntry.id);
            this.reservedId = nextLuckyEntry.id;
        }
    }

    public requestReservation(instanceReservedCallback: (id:number) => void) : number {
        this.logger.debug(LOG_TAG,  `TizenVideoReservationManager.requestReservation invoked. ReservationState is ${this.reservationState}`);
        const id: number = TizenVideoReservationManager.generateId();
        this.entries.push({
            id: id,
            callback: instanceReservedCallback
        });
        this.onChange();
        return id;
    }

    public relinquishReservation() {
        this.logger.debug(LOG_TAG,  `TizenVideoReservationManager.relinquishReservation invoked. ReservationState is ${this.reservationState}`);
        this.reservationState = "VACANT";
        this.onChange();
    }

    public cancelReservationRequest(reservationRequestId: number) : void {
        if (this.reservedId === reservationRequestId) {
            this.logger.debug(
                LOG_TAG, 
                `TizenVideoReservationManager.cancelReservationRequest(${reservationRequestId}) invoked. Matches the one just sent. Becoming VACANT`
            );
            this.reservationState = "VACANT";
            this.onChange();
        }
        else {
            const index = this.entries.findIndex(e => e.id === reservationRequestId);
            if (index != -1) {
                this.entries.splice(index, 1);
            } else {
                this.logger.debug(LOG_TAG,  `TizenVideoReservationManager.cancelReservationRequest(${reservationRequestId}) invoked. No reservation found`);
            }
    
        }
    }
}